import { render, staticRenderFns } from "./PolygonOptions.vue?vue&type=template&id=65864897"
import script from "./PolygonOptions.vue?vue&type=script&lang=ts"
export * from "./PolygonOptions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports